import InnerTable from './inner-table.jsx'

const SociogramTable = ({
  sociogram,
  surveysData,
  loading,
  errorResultRecommendations
}) => {
  return (
    <div className='inner-table-component'>
      <InnerTable
        surveysData={surveysData}
        sociogram={sociogram}
        loading={loading}
        errorResultRecommendations={errorResultRecommendations}
      />
    </div>
  )
}

export default SociogramTable
